import React, { useEffect, useState } from "react"
import { get } from "../../../../../Model/Network/Config/Axios"
import { Spinner } from "../../../../Common/fLoader"
import moment from "moment"
import SettlementApproval from "../../../fSettlements/ApprovalVendorSettlement/Detail"

export const PartialSettlements = ({invoiceId}) => {
   const [partialSettlements,setPartialSettlements] = useState([])
   const [loading,setLoading] = useState(true)
   const [showDetail,setShowDetail] = useState(false)

    useEffect(() =>{
     get(`/settlements/settlements/invoice/${invoiceId}/settlementRequests`,(e,r) =>{
		if(r){
			setPartialSettlements(r.settlementRequests.filter(item => item.referenceType === 'PARTIAL'))
		}
		setLoading(false)
	 })
    },[])


	if(loading){
		return <Spinner />
	}

	const mapCard = (item,index) => {
		return (
			<div className='FadeRight-Effect' style={{cursor:'pointer'}} onClick={() => setShowDetail(item.id)}>
				<div style={{ padding: '10px 20px', border: '1px solid var(--border-color)', position: 'relative', borderRadius: '6px', marginTop: '15px' }}>
									<div style={{fontSize: '12px', fontWeight: 'bold', marginBottom: '5px'}}>#{item.name}</div>
									<div style={{display:'flex',justifyContent:'flex-end'}}>
										<div style={{
											padding: '4px 12px',
											borderRadius: '20px',
											fontSize: '11px',
											fontWeight: '600',
											color: '#fff',
											background: item.status === 'COMPLETED' ? '#28a745' : 
														item.status === 'PENDING' ? '#ffc107' : 
														item.status === 'DECLINED' ? '#dc3545' : 
														item.status === 'COMPLETED' ? '#17a2b8' : '#6c757d',
											border: '1px solid transparent',
											display: 'inline-block',
											textTransform: 'uppercase',
											letterSpacing: '0.5px'
										}}>
											{item.status}
										</div>
									</div>
									<div key={`info-${index}`} style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Created On: </span>{moment(item.createdAt).format('HH:MM a DD-MM-YYYY')}</div>
									<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Amount: </span>{item.currency} {item.amount}</div>
									<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Ledger ID: </span>{item.ledgerId}</div>
									<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Type: </span>{item.referenceType}</div>
									{
										item.referenceType === 'INVOICES' || item.referenceType === 'POADVANCE' || item.referenceType === 'VENDORADVANCE' || item.referenceType === 'PARTIAL' ?
											<>
												<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>TDS Amount: </span>{item.tdsAmount || 0}</div>
												<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Comsumed Amount: </span>{item.paidAmount || 0}</div>
											</>
											: <></>
									}
									{item.reference && (
										<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Reference: </span>{item.reference || '-'}</div>
									)}
									{item.requestId && (
										<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Request ID: </span>{item.requestId || '-'}</div>
									)}
									{item.reverseCharge && (
										<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Reverse Charge : </span>{item.reverseCharge || '-'}</div>
									)}
									<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Transferred: </span>{item.transferred ? 'Yes' : 'No'}</div>
									{
										item.utr &&
										<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>UTR: </span>{item.utr}</div>
									}
																			
								</div>
			</div>
		)
	}

	return (
		<div>
			{partialSettlements.map((item,index) => {
				return mapCard(item,index)
			})}
			{showDetail ? <SettlementApproval onClose={() => setShowDetail(false)}  id={showDetail} /> : null}
		</div>
	)
}